export const FIN_REGEX = /^[A-Za-z0-9]{17}$/;